import { render, staticRenderFns } from "./Store2FASettings.vue?vue&type=template&id=437800e6&"
import script from "./Store2FASettings.vue?vue&type=script&lang=js&"
export * from "./Store2FASettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports